import { useNavigate } from 'react-router';
import { MBox, MButton, MText } from '../../components/Monetize';
import MPageContainer from '../../components/Monetize/MPageContainer';
import { useDashboardTab } from '../../hooks';

export const UnauthorizedPage = () => {
  const navigate = useNavigate();

  const { getDashboardTabRouteByRole } = useDashboardTab();

  const goDashboard = () => {
    navigate(getDashboardTabRouteByRole());
  };

  return (
    <MPageContainer>
      <MBox
        display="flex"
        alignItems="center"
        flexDirection="column"
        justifyContent="center"
        flex={1}
      >
        <MText fontSize="2xl" fontWeight="bold">
          Unauthorized Access
        </MText>
        <MText fontSize="large" mt={6} mb={3} textAlign="center">
          You can’t access this page because you don’t have permission.
          <br />
          If you feel you should have access, contact your administrator
        </MText>

        <MButton onClick={goDashboard} variant="secondary" my="4">
          Return to Dashboard
        </MButton>
      </MBox>
    </MPageContainer>
  );
};
